import apiClient from '../apiClient';
import { GET_TRANSPORTATION_BY_PROFILE_ID_URL } from '../apiUrl';

const getTransportationByProfileIdApi = Id => {
  return apiClient.get(GET_TRANSPORTATION_BY_PROFILE_ID_URL(Id));
};

export default getTransportationByProfileIdApi;
